
import React from 'react';
import { Button } from '@/components/ui/button';
import { CardFooter } from '@/components/ui/card';

interface ApprovalActionsProps {
  onCancel: () => void;
  onReject: () => void;
  onApprove: () => void;
  status: string;
}

export const ApprovalActions: React.FC<ApprovalActionsProps> = ({
  onCancel,
  onReject,
  onApprove,
  status
}) => {
  const isPendingFinance = status === 'pending_finance';

  return (
    <CardFooter className="flex justify-end gap-4 pt-6">
      <Button variant="outline" onClick={onCancel}>
        {isPendingFinance ? 'Cancel' : 'Back'}
      </Button>
      {isPendingFinance && (
        <>
          <Button variant="destructive" onClick={onReject}>
            Reject
          </Button>
          <Button variant="default" onClick={onApprove}>
            Approve
          </Button>
        </>
      )}
    </CardFooter>
  );
};
